import { render } from "./InstantiateTaskTemplate.vue?vue&type=template&id=f123af1a"
import script from "./InstantiateTaskTemplate.vue?vue&type=script&lang=js"
export * from "./InstantiateTaskTemplate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__